import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { MailIndex } from './screens'

function MailRoutes() {
  return (
    <Switch>
      <Route component={MailIndex} />
    </Switch>
  )
}

export { MailRoutes }
